import { defaultAPIInstance } from "../index";



export const API = {
    addToCart(product_id :number, price_id :number, dops :Array<number>, amount :number, token:string){
        const url = '/cart/item'
        const data = {
            product_id, 
            price_id, 
            dops, 
            amount
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'X-Access-Token': token
            }
        }
        return defaultAPIInstance.post(url, data, config)
    },

    getCart(token:string){
        const url = '/cart'
        return defaultAPIInstance.get(url, {
            headers: {
                'X-Access-Token': token
            }
        })
    },
    
    changeAmount(id :number, new_amount :number, token:string){
        const url = `/cart/item/${id}`
        const data = {new_amount}

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'X-Access-Token': token
            }
        }

        return defaultAPIInstance.patch(url, data, config)
    },

    deleteInCart(id :number, token:string){
        const url = `/cart/item/${id}`

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'X-Access-Token': token
            }
        }

        return defaultAPIInstance.delete(url, config)
    },
}